import Http from "../utils/Http"

export default {
    loadFAQCategories() {
        return Http.get("/api/v1/faq/category");
    },

    loadFAQs(categoryId) {
        return Http.get("/api/v1/faqs/category/" + categoryId);
    }
}